"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFormCardCms = void 0;
var AddressFormCardCms = /** @class */ (function () {
    function AddressFormCardCms() {
        this.attentionLabel = 'Attention (optional)';
        this.attentionLabelInputBoxToolTip = "The Attention line lets you provide additional info to ensure the delivery of your mail.\n    Some examples include \"In care of\" info; a company name; or the name of a room or building.";
        this.bssehardStopCTOMsg = 'Looks like you’ll need to speak to one of our service reps to complete your order. Please call us at 866.662.4548.';
        this.bsseNum = "866.662.4548";
        this.firstNameLabel = 'First Name';
        this.lastNameLabel = 'Last Name';
        this.addressLine1Label = 'Address line 1';
        this.billingAddressLine1Label = 'Billing address line 1';
        this.addressLine1InputBoxPlaceholder = 'Can\'t be a PO Box';
        this.addressLine1InputBoxPlaceholderSMB = 'Enter a physical address, not a PO Box';
        this.shippingAddressLine1InputBoxToolTip = 'Be sure to use your physical street address for shipping; not a post office box.';
        this.ppuAddressLine1InputBoxToolTip = "Sorry, but we can't accept a post office box in place of your physical street address.\n     We'll use this address for taxation purposes.";
        this.billingAddressLine1InputBoxToolTip = 'Be sure to use your physical street address for billing, not ' +
            'a post office box.  You can use a PO Box for future mailing purposes, but you\'ll need ' +
            'to provide it after you\'ve received and activated your new devices.';
        this.billingAddressLine1InputBoxToolTipSMB = 'Make sure you use your physical street address for billing, not a post office box. You can use a PO Box for future mailing purposes, but you’ll need to provide it after you’ve received and activated your new devices';
        this.addressLine2Label = 'Address line 2 (required if applicable)';
        this.billingAddressLine2Label = 'Billing address line 2 (required if applicable)';
        this.addressLine2InputBoxPlaceholder = 'Apt, unit, suite';
        this.cityLabel = 'City';
        this.stateLabel = 'State';
        this.zipLabel = 'ZIP Code';
        this.updateAddressCTALabel = 'Update my address';
        this.addAddressCTALabel = 'Add this address';
        this.updateAccountCTALabel = 'Update account info';
        this.cancelCTALabel = 'Cancel';
        this.urbanizationLabel = 'Urbanization (required if applicable)';
        this.urbanizationLabelInputBoxTooltip = "Urbanization is commonly used in urban areas of Puerto Rico.\n     If this is something you normally provide to ensure the delivery of your mail,\n     be sure to include it here. An example is \"URB Las Gladiolas.\"";
        this.callUsForHelpLabel = 'Please call us at <strong>888.333.6651</strong>, so we can help with your order.';
        this.noMatchRetryAttemptCountLabel = 2;
        this.libertyCTOErrLabel = 'Want wireless service in Puerto Rico or the U.S. Virgin Islands? Liberty Communications will be your new wireless provider. Please call 800.331.0500 to place your order.';
        this.smbVerifyAddressCTALabel = 'Verify Address';
        this.smbAddBillingAndShippingCTALabel = 'Add billing and shipping info';
        this.smbAddBillingCTALabel = 'Add billing info';
        this.smbAddBusinessInfoCTALabel = 'Add business info';
        this.smbContinueCTALabel = 'Continue';
        this.smbShipptingAddressDescription = 'The shipping address must be the same as the service address.';
        this.smbShipptingAddressTitleLabel = 'Shipping address';
        this.smbTooltipForBusinessAddress = 'Make sure you use your physical street address for billing, not a post office box. You can use a PO Box for future mailing purposes, but you’ll need to provide it after you’ve received and activated your new devices.';
    }
    return AddressFormCardCms;
}());
exports.AddressFormCardCms = AddressFormCardCms;
//# sourceMappingURL=addressformcard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/AddressFormCard/addressformcard.cms.js
// module id = 947
// module chunks = 8